import React from 'react';
import { Responsive, SimpleList, Filter, List, Edit, Create, Datagrid, EditButton, SimpleForm, required, TextInput,
  TextField,SimpleShowLayout} from 'react-admin';
import { Field } from 'redux-form'
import FormLabel from '@material-ui/core/FormLabel';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import { resources_by_name } from './pkadmin/resources.js'
import MyParentComponentWrapper from "./MyParentComponentWrapper";


const SchoolsFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
    </Filter>
);

const SchoolsListTitle = ({ record }) => {
    return <span>School Profile</span>;
};

export const SchoolsList = (props) => (
    <div>
    <Card>
        <CardContent>
          <p>View and create your school's profile here. (To create more than one school and search for teachers you need an agency account)</p>
        </CardContent>
    </Card>
    <br />
    <List title={<SchoolsListTitle />} {...props} filters={<SchoolsFilter />}>
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.schoolname}
                    secondaryText={record => record.adminname}
                    tertiaryText={record => record.email}
                />
            }
            medium={
                <Datagrid>
                     <TextField source="id" />
                     <TextField label="School Name" source="schoolname" />
                     <TextField label="Administrator" source="adminname" />
                     <TextField label="Email" source="email" />
                     <TextField label="Phone Number" source="phonenumber" />

                    <EditButton />
                </Datagrid>
            }
        />
    </List>
    </div>
);

const SchoolsCreateEditTitle = ({ record }) => {
    return <span>Schools {record ? `"${record.id}"` : ''}</span>;
};

export const SchoolsEdit = (props) => {
    console.log('props.location.search', props.location.search)
    return <Edit title={<SchoolsCreateEditTitle />}  {...props}>
        <SimpleForm defaultValue={{lat: 53.3423, lng: -6.25}}>
            <TextInput
              className="md-cell md-cell--top"
              label="School Name"
              name="schoolname"
              validate={required('Required')}
              source="schoolname"
              {...resources_by_name['schools']['field_args']}/>
            <TextInput
              className="md-cell md-cell--top"
              label="Administrator Full-name"
              name="adminname"
              validate={required('Required')}
              source="adminname"
              {...resources_by_name['schools']['field_args']}/>
            <TextInput
              className="md-cell md-cell--top"
              label="Email"
              name="email"
              validate={required('Required')}
              source="email"
              type="email"
              {...resources_by_name['schools']['field_args']}/>
            <TextInput
              className="md-cell md-cell--top"
              label="Phone Number"
              name="phonenumber"
              validate={required('Required')}
              source="phonenumber"
              {...resources_by_name['schools']['field_args']}/>
            <br />
            <FormLabel component="legend">Select Your Location on the map below</FormLabel>
            <MyParentComponentWrapper />
            <Field name="lat" component="input" type="hidden" step="0.01" />
            <Field name="lng" component="input" type="hidden" step="0.01" />

        </SimpleForm>
    </Edit>
}

export const SchoolsCreate = (props) => (
    <Create title={<SchoolsCreateEditTitle />}  {...props}>
        <SimpleForm redirect="list" defaultValue={{lat: 53.3423, lng: -6.25}}>
            <TextInput
              className="md-cell md-cell--top"
              label="School Name"
              name="schoolname"
              validate={required('Required')}
              source="schoolname"
              {...resources_by_name['schools']['field_args']}/>
            <TextInput
              className="md-cell md-cell--top"
              label="Administrator Full-name"
              name="adminname"
              validate={required('Required')}
              source="adminname"
              {...resources_by_name['schools']['field_args']}/>
            <TextInput
              className="md-cell md-cell--top"
              label="Email"
              name="email"
              validate={required('Required')}
              source="email"
              type="email"
              {...resources_by_name['schools']['field_args']}/>
            <TextInput
              className="md-cell md-cell--top"
              label="Phone Number"
              name="phonenumber"
              validate={required('Required')}
              source="phonenumber"
              {...resources_by_name['schools']['field_args']}/>
            <br />
            <FormLabel component="legend">Select Your Location on the map below</FormLabel>
            <MyParentComponentWrapper />
            <Field name="lat" component="input" type="hidden" step="0.01" />
            <Field name="lng" component="input" type="hidden" step="0.01" />


        </SimpleForm>
    </Create>
);

export const SchoolsShow = (props) => (
    <Create title={<SchoolsCreateEditTitle />}  {...props}>
        <SimpleShowLayout>
            <TextField source="question" />
            <TextField source="category"/>
            <TextField source="contributes" />
        </SimpleShowLayout>
    </Create>
);
